// extracted by mini-css-extract-plugin
export default {"societySelect":"TowerManagement_societySelect__7CoZR","loading":"TowerManagement_loading__JvYv7"};